export enum TourPageSections {
  HIGHLIGHTS = 'tour__page-section--highlights',
  ITINERARY = 'common__label--itinerary',
  PRICING = 'common__label--dates-and-prices',
  ACCOMMODATION = 'tour__information-title--accommodation',
  VESSELS = 'vessel-info-group__heading--title',
  REVIEWS = 'common__label--reviews',
  EXTENSIONS = 'tour__page-section--extensions',
  IMPORTANT_INFO = 'tour__page-section--info'
}
